module.exports = __webpack_public_path__ + "fonts/SamsungOne-200C_v1.1.23674eda.ttf";